import { useIntl } from 'react-intl';

import { ProfileImage } from '@xing-com/profile-image';

import { CompanyLink } from './company-link';

type Props = {
  link?: string;
  trackingParams?: string;
  logo?: string;
};

export const CompanyImage: React.FC<Props> = ({
  link,
  trackingParams,
  logo,
}) => {
  const { formatMessage } = useIntl();

  return (
    <CompanyLink
      link={link}
      trackingParams={trackingParams}
      aria-label={formatMessage({
        id: 'JOBS_JOB_DETAILS_COMPANY_MODULE_CARD_LINK_LABEL',
      })}
    >
      <ProfileImage
        type="company"
        size="small"
        sizeConfined="medium"
        src={logo}
        aria-hidden
      />
    </CompanyLink>
  );
};
